import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useDeleteAircraftType } from '@/hooks/useAircraftTypes'

interface DeleteAircraftTypeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  aircraftTypeId: string
  aircraftTypeName: string
}

export function DeleteAircraftTypeDialog({
  open,
  onOpenChange,
  aircraftTypeId,
  aircraftTypeName,
}: DeleteAircraftTypeDialogProps) {
  const deleteMutation = useDeleteAircraftType()

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync(aircraftTypeId)
      onOpenChange(false)
    } catch {
      // Error handling is done in the mutation hook
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Aircraft Type</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete <strong>"{aircraftTypeName}"</strong>?
            <br />
            <br />
            This is a global reference type. Deleting it may affect other records
            that reference this aircraft type. This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={deleteMutation.isPending}
          >
            {deleteMutation.isPending ? 'Deleting...' : 'Delete Aircraft Type'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
